

































































































import { Component, Watch } from 'vue-property-decorator'
import api from "../../api/index"
import Lists from '../components/Lists.vue'
import { Action, Getter } from 'vuex-class'
import ConfirmModal from '../components/ConfirmModal.vue'

@Component({
  components: {
    ConfirmModal
  }
})
export default class Utilisateurs extends Lists {
  isLoading = true
  dataType = 'admins'
  dataTypeLabel = 'administrateur'
  users = []
  selectedUser = null

  wordSearched = ""

  @Getter('admin') admin:any


  head() {
    return {
      title: 'Utilisateurs',
      meta: [{
        breadcrumb: 'Utilisateurs'
      }]
    }
  }

  get totalRows() {
    return this.users.length < this.perPage ? this.users.length : this.perPage
  }

  goToUser(row:any) {
    const userId = row.id
    this.$router.push({ name: 'userProfile', params: { userId }})
  }

  @Watch('perPage')
  @Watch('wordSearched')
  @Watch('currentPage')
  onSearchPropsChanged(val: any, old: any) {
    if ((old && val && val.toString() === old.toString()) || this.isLoading) {
      return
    }
    this.getAllUsers()
  }

  getFilteredName(user:any) {
    let gender
    if (user.gender === "male") {
      gender = "M."
    } else if (user.gender === "female") {
      gender = "Mme"
    } else {
      gender = ""
    }
    var firstName = user.first_name || ""
    firstName = firstName.toLowerCase()
    firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1)
    var lastName = user.last_name || ""
    lastName = lastName.toLowerCase()
    lastName = lastName.charAt(0).toUpperCase() + lastName.slice(1)
    return gender + " " + firstName + " " + lastName
  }

  async fetchData() {
    this.getAllUsers()
  }

  async getAllUsers() {
    try {
      const res = await api.get("bo/users", { params: {
        page: this.currentPage,
        per_page: this.perPage,
        keywords: this.wordSearched,
        order: this.sortField,
        order_desc: this.sortOrder
      }})
      this.totalPages = parseInt(res.headers["x-pagination-total-pages"])
      this.totalResults = parseInt(res.headers["x-pagination-total"])
      this.perPage = parseInt(res.headers["x-pagination-per-page"])

      this.users = res.data
    } catch (e) {
      if (e.response.status === 401) {
        console.log(e.response.status)
      }
    }
  }

  async mounted() {
    await api.setToken()
    this.isLoading = true
    await this.getAllUsers()
    this.isLoading = false
  }

  async suspendUser(userId:any) {
    try {
      const res = await api.post("bo/users/" + userId + "/suspension", {})
      await this.getAllUsers()
    } catch (e) {
      if (e.response.status !== 201) {
        console.log(e.response.status)
      }
    }
  }
  async reactivateUser(userId:any) {
    try {
      const res = await api.delete("bo/users/" + userId + "/suspension")
      await this.getAllUsers()
    } catch (e) {
      if (e.response.status !== 200) {
        console.log(e.response.status)
      }
    }
  }
  async deleteUser() {
    if (!this.selectedUser) return
    try {
      const res = await api.delete(`bo/users/${this.selectedUser}`)
      this.selectedUser = null
      await this.getAllUsers()
    } catch (e) {
      if (e.response.status !== 200) {
        console.log(e.response.status)
      }
    }
  }
}
